import diff from 'deep-diff';

const propertyReducer = (properties, state) => {
  return properties.reduce((acc, curr) => {
    return Object.assign({}, acc, {
      [curr]: state[curr],
    });
  }, {});
};

export default ({ storageResolver, properties }) => ({
  getState,
}) => next => action => {
  const leftValue = propertyReducer(properties, getState());
  //const leftValue = { currentUser: getState().currentUser };
  let result = next(action);
  const rightValue = propertyReducer(properties, getState());
  const differences = diff(leftValue, rightValue);
  if (differences) {
    storageResolver.save(rightValue);
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/store/persistentStateMiddleware.js